<template>
  <img
    v-if="displayCarrier"
    :src="`/static/images/carrier/${displayCarrier}`"
    :height="imgHeight"
    :width="imgWidth"
    style="vertical-align: middle;"
  >
</template>
<script>
const icons = [
  'youshuwuliu.png',
  'shunfeng.png',
  'tstexp.png',
  'danniao.png',
  'suer.png',
  'kkren.png',
  'baishiwuliu.png',
  'tccs.png',
  'yuantong.png',
  'pch2.png',
  'fami.png',
  'pch.png',
  'xinfengwuliu.png',
  '711.png',
  'sf.png',
  'fmart.png',
  'jd.png',
  'dhlen.png',
  'jtexpress.png',
  'youzhengguonei.png',
  'shentong.png',
  'huitongkuaidi.png',
  'cvs.png',
  'yunda.png',
  'ems.png',
  'ktj.png',
  'tiantian.png',
  'hilife.png',
  'debangwuliu.png',
  'annengwuliu.png',
  'ty.png',
  'bld.jpg',
  'bld.png',
  'tcat.png',
  'hct.png',
  'zhongtong.png',
  'zhongtongkuaiyun.png',
  'magicbuy.png',
  'van.png',
]
export default {
  props: {
    carrier: String,
    width: String,
    height: String,
  },
  computed: {
    imgHeight () {
      if (this.carrier === 'pch') {
        return 'none'
      }
      return this.height
    },
    imgWidth () {
      if (this.carrier === 'pch') {
        // return '30'
      }
      if (!this.width && !this.height) {
        return '20'
      }
      return this.width
    },
    displayCarrier () {
      return icons.find(icon => icon === `${this.carrier}.png`)
    },
  }
}
</script>
